import { graphql } from 'react-relay';

export const WelcomeMessagesQuery = graphql`
	query WelcomeMessagesQuery {
		spaViewContext {
			welcomeMessageEditUrl
			welcomeMessageHtml
			isWelcomeMessageCustomized
			resourceKeys
			resourceContexts
			showWelcomeMessageEditHint
			showEditButton
		}
	}
`;
